import { cn } from '@/lib/utils';
import { formatGradingCompany } from '@/constants/gradingCompanies';
import {
  CONDITION_ABBREVIATIONS,
  CONDITION_COLORS,
  type ListingCondition,
} from '@/types/listing';

interface ItemMetaBadgesProps {
  category?: string | null;
  condition?: string | null;
  gradingCompany?: string | null;
  slabGrade?: number | null;
  className?: string;
}

/**
 * Shared grade/condition pills used by Inventory cards and Market tiles
 * so both surfaces stay visually cohesive.
 */
export function ItemMetaBadges({
  category,
  condition,
  gradingCompany,
  slabGrade,
  className,
}: ItemMetaBadgesProps) {
  const grade = slabGrade != null ? Number(slabGrade) : null;

  return (
    <>
      {category === 'slabs' && gradingCompany && grade != null && (
        <span
          className={cn(
            'text-[11px] lg:text-[10px] px-2 py-0.5 lg:px-1 rounded-full border whitespace-nowrap',
            grade >= 9
              ? 'border-success/50 text-success bg-success/10'
              : grade >= 7
              ? 'border-info/50 text-info bg-info/10'
              : grade >= 5
              ? 'border-warning/50 text-warning bg-warning/10'
              : grade >= 4
              ? 'border-caution/50 text-caution bg-caution/10'
              : 'border-destructive/50 text-destructive bg-destructive/10',
            className,
          )}
        >
          {formatGradingCompany(gradingCompany)} {slabGrade}
        </span>
      )}

      {category === 'singles' && condition && CONDITION_ABBREVIATIONS[condition as ListingCondition] && (
        <span
          className={cn(
            'text-[11px] lg:text-[10px] px-2 py-0.5 lg:px-1 rounded-full border whitespace-nowrap',
            CONDITION_COLORS[condition as ListingCondition],
            className,
          )}
        >
          {CONDITION_ABBREVIATIONS[condition as ListingCondition]}
        </span>
      )}
    </>
  );
}
